import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row, Button, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { loader } from "../../loader";
import ArticleView from "../CommonComponent/ArticleView";
import { getEventCollection } from "../../actions";
import { connect } from "react-redux";

var eventsetupData = {};
const EventCollectionContent = (props) => {
    let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;

    const navigate = useNavigate();

    const [show, setShow] = useState(false);
    const [dataFetchInProcess, setDataFetchInProcess] = useState(false);
    const [articleListData, setArticleListData] = useState([]);
    const [currentSelectedSublink,setCurrentSelectedSublink]=useState("")
    const [pdfSelected, setPdfSelected] = useState(
        eventsetupData?.setUpData?.selectedContent ? eventsetupData?.setUpData?.selectedContent?.map(item => item.id) : []
    );
    const [selectedContent, setSelectedContent] = useState(
        eventsetupData?.setUpData?.selectedContent ? eventsetupData.setUpData.selectedContent : []
    );
    const [page, setPage] = useState(2);
    const [searchTerm, setSearchTerm] = useState('');
    const [deletestatus, setDeleteStatus] = useState(false);
    const rdLikeArray = [
        "56Ek4feL/1A8mZgIKQWEqg==",
        "bWmUjqX7J011   WUTYn9g==",
        "MXl8m36VZFYXpgFVz3Pg0g==",
    ];
    const isLikeRdAccount = rdLikeArray.includes(localStorage.getItem("user_id"));
    const deletButtonColor = isLikeRdAccount ? "#8A4E9C" : "#8A4E9C";
    
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        if (searchTerm.trim() === "") {
            getAllArticles(true);
        }
    }, [searchTerm]);

    const getAllArticles = async (reset = false) => {
        if (reset) {
            setPage(2);
            setArticleListData([]);
        }
        setDataFetchInProcess(true);
        loader("show");

        const body = {
            user_id: localStorage.getItem("user_id"),
            search: searchTerm,
            filter: {},
        };

        axios
            .post(`emailapi/get_content_list?page=${reset ? 2 : page}`, body)
            .then((res) => {
                const newData = res?.data?.response?.data || [];
                setArticleListData(newData)
                // setArticleListData((prev) =>
                //     reset ? newData : [...prev, ...newData]
                // );

                setPage((prev) => reset ? 2 : prev + 1);
                setDataFetchInProcess(false);
            })
            .catch((err) => {
                console.log(err);
                toast.error("Something went wrong");
            })
            .finally(() => {
                loader("hide");
            });
    };


    const handleSelect = (id) => {
        setPdfSelected((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        if (!searchTerm.trim()) {
            toast.warning("Please enter a search term");
            return;
        }
        getAllArticles(true);
    };

    const addContent = (e) => {
        if(pdfSelected.length > 0){
            handleClose();
            const allData = articleListData?.filter(item => pdfSelected.includes(item.id));
            setSelectedContent(allData);
        }else{
            toast.warning("Please select the content");
            return;
        }
    }

    const showDeleteButtons = () => {
        if (deletestatus) {
            setDeleteStatus(false);
        } else {
            setDeleteStatus(true);
        }
    };

    const deleteContent = (id) => {
        setPdfSelected((prevSelected) => prevSelected.filter(itemId => itemId !== id));
        setSelectedContent((prevSelected) => prevSelected.filter(item => item.id !== id));
    }

    const createCollection = async() => {
        await updateCollectionData();
        navigate("/webinar/event/event-collection-page");
    }

    const backCollection = async(e) => {
        e.preventDefault();
        await updateCollectionData();
        navigate("/webinar/event/event-collection-create");
    }

    const updateCollectionData = async() => {
        const body = {
            selectedContent: selectedContent,
        };

        let updateArticleCollectionData = {
            ...eventsetupData,
            setUpData: {
                ...eventsetupData?.setUpData,
                ...body,
            },
        };
        await props.getEventCollection(updateArticleCollectionData);
    }

    return (
        <>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
            <Col className="right-sidebar custom-change event-collection">
                <div className="container-fluid">
                    <div className="row">
                        <div className="top-right-action preview">
                            <div className="d-flex flex-column w-100">
                                <div className="page-top-nav sticky">
                                    <Row className="justify-content-end align-items-center">
                                        <Col md={1}>
                                            <div className="header-btn-left">
                                                <button className="btn btn-primary btn-bordered back"
                                                    onClick={(e) => backCollection(e)}
                                                >
                                                    Back
                                                </button>
                                            </div>
                                        </Col>
                                        <Col md={9}>
                                            <ul className="tabnav-link">
                                                <li className="">
                                                    <Link to="">Select your content collection</Link>
                                                </li>
                                                <li className="active active-main">
                                                    <Link to="">Set-up collection page</Link>
                                                </li>
                                                <li className="">
                                                    <Link to="">Set-Up Registration pop-up</Link>
                                                </li>
                                            </ul>
                                        </Col>
                                        <Col md={2}>
                                            <div className="header-btn">
                                                <Link className="btn btn-primary btn-bordered move-draft" 
                                                    to="/webinar/event/event-collection">
                                                    Cancel
                                                </Link>
                                                <Button className= {`btn-filled next ${selectedContent?.length > 0 ? "" : "disabled"}`} onClick={createCollection}>
                                                    Next
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                        <div className="top-header">
                            <div className="page-title"><h4>Selected content collection | {selectedContent?.length}</h4></div>
                            <div className="top-right-action flex-wrap">
                                {
                                    selectedContent?.length > 0 ?
                                    <>
                                        <div className="action-btn-add" style={{margin:"0"}}>
                                            <button type="button" className="btn-dashed btn btn-primary" onClick={handleShow}>Add Content
                                                <img src={path_image + "add-icon.png"} alt="" />
                                            </button>
                                        </div>
                                        <div className="clear-search">
                                            {deletestatus ? (
                                            <button
                                                className="btn btn-outline-primary cancel"
                                                onClick={(e) => showDeleteButtons()}
                                            >
                                                Cancel
                                            </button>
                                            ) : (
                                            <button
                                                className={`btn btn-outline-primary`}
                                                onClick={(e) => showDeleteButtons()}
                                            >
                                                <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                >
                                                <path
                                                    d="M15.84 22.25H8.15989C7.3915 22.2389 6.65562 21.9381 6.09941 21.4079C5.5432 20.8776 5.20765 20.157 5.15985 19.39L4.24984 5.55C4.24518 5.44966 4.26045 5.34938 4.29478 5.25498C4.32911 5.16057 4.38181 5.07391 4.44985 5C4.51993 4.9234 4.60479 4.86177 4.69931 4.81881C4.79382 4.77584 4.89606 4.75244 4.99985 4.75H19C19.1029 4.74977 19.2046 4.7707 19.2991 4.81148C19.3935 4.85226 19.4785 4.91202 19.5488 4.98704C19.6192 5.06207 19.6733 5.15077 19.7079 5.24761C19.7426 5.34446 19.7569 5.44739 19.75 5.55L18.88 19.39C18.8317 20.1638 18.4905 20.8902 17.9258 21.4214C17.3611 21.9527 16.6153 22.249 15.84 22.25ZM5.83986 6.25L6.60987 19.3C6.63531 19.6935 6.80978 20.0625 7.09775 20.3319C7.38573 20.6013 7.76555 20.7508 8.15989 20.75H15.84C16.2336 20.7485 16.6121 20.5982 16.8996 20.3292C17.1871 20.0603 17.3622 19.6927 17.39 19.3L18.2 6.3L5.83986 6.25Z"
                                                    fill={deletButtonColor}
                                                />
                                                <path
                                                    d="M20.9998 6.25H2.99999C2.80108 6.25 2.61032 6.17098 2.46967 6.03033C2.32902 5.88968 2.25 5.69891 2.25 5.5C2.25 5.30109 2.32902 5.11032 2.46967 4.96967C2.61032 4.82902 2.80108 4.75 2.99999 4.75H20.9998C21.1987 4.75 21.3895 4.82902 21.5301 4.96967C21.6708 5.11032 21.7498 5.30109 21.7498 5.5C21.7498 5.69891 21.6708 5.88968 21.5301 6.03033C21.3895 6.17098 21.1987 6.25 20.9998 6.25Z"
                                                    fill={deletButtonColor}
                                                />
                                                <path
                                                    d="M15 6.25009H9C8.80189 6.2475 8.61263 6.16765 8.47253 6.02755C8.33244 5.88745 8.25259 5.69819 8.25 5.50007V3.70004C8.26268 3.18685 8.47219 2.69818 8.83518 2.33519C9.19816 1.9722 9.68682 1.76268 10.2 1.75H13.8C14.3217 1.76305 14.8177 1.97951 15.182 2.35319C15.5463 2.72686 15.7502 3.22815 15.75 3.75004V5.50007C15.7474 5.69819 15.6676 5.88745 15.5275 6.02755C15.3874 6.16765 15.1981 6.2475 15 6.25009ZM9.75 4.75006H14.25V3.75004C14.25 3.63069 14.2026 3.51623 14.1182 3.43184C14.0338 3.34744 13.9193 3.30003 13.8 3.30003H10.2C10.0807 3.30003 9.96619 3.34744 9.8818 3.43184C9.79741 3.51623 9.75 3.63069 9.75 3.75004V4.75006Z"
                                                    fill={deletButtonColor}
                                                />
                                                <path
                                                    d="M15 18.25C14.8019 18.2474 14.6126 18.1676 14.4725 18.0275C14.3324 17.8874 14.2526 17.6981 14.25 17.5V9.5C14.25 9.30109 14.329 9.11032 14.4697 8.96967C14.6103 8.82902 14.8011 8.75 15 8.75C15.1989 8.75 15.3897 8.82902 15.5303 8.96967C15.671 9.11032 15.75 9.30109 15.75 9.5V17.5C15.7474 17.6981 15.6676 17.8874 15.5275 18.0275C15.3874 18.1676 15.1981 18.2474 15 18.25Z"
                                                    fill={deletButtonColor}
                                                />
                                                <path
                                                    d="M9 18.25C8.80189 18.2474 8.61263 18.1676 8.47253 18.0275C8.33244 17.8874 8.25259 17.6981 8.25 17.5V9.5C8.25 9.30109 8.32902 9.11032 8.46967 8.96967C8.61032 8.82902 8.80109 8.75 9 8.75C9.19891 8.75 9.38968 8.82902 9.53033 8.96967C9.67098 9.11032 9.75 9.30109 9.75 9.5V17.5C9.74741 17.6981 9.66756 17.8874 9.52747 18.0275C9.38737 18.1676 9.19811 18.2474 9 18.25Z"
                                                    fill={deletButtonColor}
                                                />
                                                <path
                                                    d="M12 18.25C11.8019 18.2474 11.6126 18.1676 11.4725 18.0275C11.3324 17.8874 11.2526 17.6981 11.25 17.5V9.5C11.25 9.30109 11.329 9.11032 11.4697 8.96967C11.6103 8.82902 11.8011 8.75 12 8.75C12.1989 8.75 12.3897 8.82902 12.5303 8.96967C12.671 9.11032 12.75 9.30109 12.75 9.5V17.5C12.7474 17.6981 12.6676 17.8874 12.5275 18.0275C12.3874 18.1676 12.1981 18.2474 12 18.25Z"
                                                    fill={deletButtonColor}
                                                />
                                                </svg>
                                            </button>
                                            )}
                                        </div>
                                    </>
                                    : null
                                }
                            </div>
                        </div>
                        <div className="email-result survey-listing">
                            <div className="col email-result-block library-content-box-layout">
                                <div className="mail_trigger_right_dummy w-100">
                                    {
                                        selectedContent?.length > 0 ?
                                        <ArticleView
                                            articleData = {selectedContent}
                                            primaryLink = {0}
                                            is_selectable = {0}
                                            deleteStatus = {deletestatus}
                                            deleteContent = {deleteContent}
                                        /> :
                                        <div className="mail_trigger_dummy_content d-flex justify-content-center">
                                            <h3>Start adding your content collection by clicking below</h3>
                                            <Button className="btn-filled" onClick={handleShow}>Add Content <img src={path_image + "add-icon.png"} alt="" /></Button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </Col>
            <div className="modal">
                <Modal id="add-list" className="add-collection" show={show} onHide={handleClose} custom-atr="non-scroll">
                    <Modal.Header closeButton>
                        <Modal.Title>Add Content collection</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="top-right-action">
                            <div className="search-bar">
                                <form className="d-flex" onSubmit={handleSearchSubmit}>
                                    <input
                                        className="form-control me-2"
                                        type="search"
                                        placeholder="Search"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <button className="btn btn-outline" type="submit" disabled={!searchTerm.trim()}>
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M15.8045 14.862L11.2545 10.312C12.1359 9.22334 12.6665 7.84 12.6665 6.33334C12.6665 2.84134 9.82522 0 6.33325 0C2.84128 0 0 2.84131 0 6.33331C0 9.82531 2.84132 12.6667 6.33328 12.6667C7.83992 12.6667 9.22325 12.136 10.3119 11.2547L14.8619 15.8047C14.9919 15.9347 15.1625 16 15.3332 16C15.5039 16 15.6745 15.9347 15.8045 15.8047C16.0652 15.544 16.0652 15.1227 15.8045 14.862ZM6.33328 11.3333C3.57597 11.3333 1.33333 9.09066 1.33333 6.33331C1.33333 3.57597 3.57597 1.33331 6.33328 1.33331C9.0906 1.33331 11.3332 3.57597 11.3332 6.33331C11.3332 9.09066 9.09057 11.3333 6.33328 11.3333Z"
                                                fill="#97B6CF"
                                            ></path>
                                        </svg>
                                    </button>
                                </form>
                            </div>
                        </div>
                        {
                            articleListData?.length > 0 ?
                            <ArticleView
                                articleData = {articleListData}
                                primaryLink = {0}
                                is_selectable = {1}
                                pdfSelected={pdfSelected}
                                onPdfToggle={handleSelect}
                                selectedSublink={0}
                                setCurrentSelectedSublink = {setCurrentSelectedSublink}
                            />
                            :
                            !dataFetchInProcess ?
                            "No Data Found"
                            : null
                        }

                        {/* {
                            page <= 2 && articleListData.length > 29  && (
                                <button onClick={() => getAllArticles(false)} className="btn btn-primary load-more">
                                    Load More
                                </button>
                            )
                        } */}
                    </Modal.Body>
                    <Modal.Footer>
                        <button onClick={(e) => addContent(e)} className="btn btn-primary">
                            Add
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
            
        </>
    )
}

const mapStateToProps = (state) => {
  eventsetupData = state?.getEventCollection;
  return state;
};

export default connect(mapStateToProps, { getEventCollection: getEventCollection })(
  EventCollectionContent
);